// i18n area 'auth' — locale ru-RU (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.ru-RU.meta.json.
import type { enUS } from './auth'

export const ruRU: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Войдите в свою учетную запись',
    username: 'Имя пользователя',
    usernamePlaceholder: 'Введите имя пользователя',
    usernameHint: 'Указывайте пользователь@домен, чтобы пройти проверку в реалме каталога',
    continue: 'Продолжить',
    changeUser: 'Это не вы?',
    password: 'Пароль',
    forgotPassword: 'Забыли пароль?',
    submit: 'Войти',
    otp: 'Одноразовый код',
    otpSubtitle: 'Введите код из приложения-аутентификатора',
    otpHint: 'Шесть цифр из приложения аутентификации либо один из кодов восстановления',
    otpSubmit: 'Проверить',
    invalidCredentials: 'Неверное имя пользователя или пароль',
    tooManyAttempts: 'Слишком много попыток — подождите немного и повторите',
    realmUnavailable: 'Реалм сейчас не может проверить учетные данные — хранилище конфигурации кластера недоступно. Войдите локальным пользователем (аварийный вход).',
    genericError: 'Не удалось войти — доступен ли бэкенд TVirt?'
  },
  user: {
    logout: 'Выйти',
    password: {
      menu: 'Сменить пароль',
      title: 'Смена вашего пароля',
      current: 'Текущий пароль',
      new: 'Новый пароль',
      confirm: 'Подтвердите новый пароль',
      mismatch: 'Пароли не совпадают',
      error: 'Не удалось сменить пароль',
      forcedTitle: 'Смените пароль, чтобы продолжить',
      forcedHint: 'Этот пароль задал администратор, и перед входом его нужно заменить.',
      forcedSubmit: 'Сменить и войти'
    },
    mfa: {
      title: 'Двухфакторная аутентификация',
      subtitle: 'Второй фактор запрашивается при каждом входе',
      loadError: 'Не удалось загрузить состояние второго фактора',
      enrolled: 'Включен',
      notEnrolled: 'Не включен',
      enrolledAt: 'Дата включения',
      codesRemaining: 'Осталось кодов восстановления',
      requiredHint:
        'Администратор требует второй фактор для этой учетной записи: настройте его сейчас — пока этого не сделано, войти вы сможете, но немногим больше.',
      enroll: 'Настроить',
      enrollTitle: 'Настройка двухфакторной аутентификации',
      enrollHint: 'Наведите приложение аутентификации на этот код, затем введите показанный им код для подтверждения.',
      secretHint: 'Не получается отсканировать? Введите этот секрет в приложении:',
      code: 'Код из приложения',
      confirm: 'Подтвердить',
      startError: 'Не удалось начать настройку',
      confirmError: 'Не удалось подтвердить настройку',
      codesTitle: 'Ваши коды восстановления',
      codesWarning:
        'Эти коды показываются один-единственный раз. Сохраните их сейчас: каждый из них дает вход, когда аутентификатор недоступен, и срабатывает лишь однажды.',
      codesAck: 'Коды восстановления сохранены',
      codesDone: 'Готово',
      copy: 'Копировать',
      copied: 'Скопировано',
      download: 'Скачать',
      regenerate: 'Новые коды восстановления',
      regenerateTitle: 'Перевыпустить коды восстановления',
      regenerateHint: 'Все выданные до сих пор коды перестают работать в тот момент, когда создается новый набор.',
      regenerateConfirm: 'Перевыпустить',
      regenerateError: 'Не удалось перевыпустить коды восстановления',
      remove: 'Убрать',
      removeTitle: 'Убрать второй фактор',
      removeConfirm: 'Убрать',
      removeHint: 'Учетная запись вернется к одному только паролю. Второй фактор можно настроить заново в любой момент.',
      removeRequiredHint:
        'Администратор требует второй фактор для этой учетной записи, поэтому сервер отклонит его снятие — сначала попросите отменить это требование.',
      removeError: 'Не удалось убрать второй фактор'
    },
    profile: {
      menu: 'Перейти в мой профиль',
      sessions: 'Активные сеансы',
      sessionsHint: 'Ваши открытые сеансы на этом узле',
      sessionsEmpty: 'Активных сеансов нет',
      sessionCreated: 'Вход выполнен',
      sessionExpires: 'Истекает',
      revoke: 'Отозвать сеанс',
      revokeError: 'Не удалось отозвать сеанс',
      loadError: 'Не удалось загрузить сеансы'
    }
  }
}
